import Vue from 'vue'

import * as types from './mutation-types'

export default {
  [types.SET_EMPLOYEE_LIST] (state, employees) {
    Vue.set(state, 'employees', employees)
  },
  [types.SET_STORE_CONNECTION_CLIENTS] (state, clients) {
    Vue.set(state, 'currentStoreConnectionClients', clients)
  }
}
